import { useState } from 'react'

import { RequestStatus } from 'core/domain/Request'
import { useAbortController } from 'core/ui/hooks/useAbortController'

import { uploadToOpenDockStorage } from '../../use-cases/uploadToOpenDockStorage'

export function useUploadToOpenDockStorage() {
  const abortController = useAbortController()
  const [status, setStatus] = useState<RequestStatus>(RequestStatus.Initial)

  async function call(shipmentUUID: string, file: File) {
    setStatus(RequestStatus.Pending)

    try {
      if (!abortController.signal.aborted) {
        const result = await uploadToOpenDockStorage({
          shipmentUUID,
          file,
          config: abortController,
        })
        setStatus(RequestStatus.Done)
        return result
      }
    } catch (error) {
      if (abortController.signal.aborted) return
      setStatus(RequestStatus.Error)
      throw error
    }
  }

  return { call, status }
}
